module.exports = __webpack_public_path__ + "static/media/pricing-hero-bg-mob.a6179b89.png";